import React from "react";
import {
  People,
  ContentPaste,
  BarChart,
  Settings,
  ExitToApp,
  MailOutline,
  Gavel,
  QueryStatsRounded,
} from "@mui/icons-material";
import SideMenu from "../../../components/SideMenu/SideMenu";

const MenuLateralAdmin = ({ setCurrentView, currentView, handleClose }) => {
  const menuItems = [
    { text: "Gerenciar Usuários", icon: <People />, view: "usuarios" },
    { text: "Vendas e Pagamentos", icon: <QueryStatsRounded />, view: "vendas_pagamentos" },
    { text: "Gerenciar Conteúdo", icon: <ContentPaste />, view: "conteudo" },
    { text: "Relatórios", icon: <BarChart />, view: "relatorios" },
    { text: "Chargebacks", icon: <Gavel />, view: "chargebacks" },
    { text: "Entregabilidade E-mail", icon: <MailOutline />, view: "email_webhooks" },
    { text: "Configurações", icon: <Settings />, view: "configuracoes" },
    {
      text: "Sair",
      icon: <ExitToApp />,
      action: () => {
        localStorage.removeItem("token");
        window.location.href = "/login";
      },
    },
  ];

  return (
    <SideMenu
      setCurrentView={setCurrentView}
      handleClose={handleClose}
      menuItems={menuItems}
      title="Future Trade"
      subtitle="Painel Admin"
      description="Gerenciamento da plataforma"
      defaultActiveView="usuarios"
      currentView={currentView}
    />
  );
};

export default MenuLateralAdmin;
